import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SidenavService } from '@shared/services/sidenav.service';
import { SidebarItem } from '@shared/sidebaritem';
import { sidebarItems } from './menu';

@Component({
	selector: 'app-setup',
	templateUrl: './setup.component.html',
	styleUrl: './setup.component.css',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SetupComponent implements OnInit {
	sidebarItems: SidebarItem[] = sidebarItems;

	constructor(private sidenavService: SidenavService) {}

	ngOnInit(): void {
		this.sidenavService.setMenuData(this.sidebarItems);
		void this.sidenavService.closeRightPanel();
	}
}
